import React, { useEffect, useState } from "react";
import { a11yProps } from "../../Helpers/CustomTabPanel/CustomTabPanel";
import { StyledBadge } from "../RegistrationRequest/RegistrationRequest";
import { Tooltip } from "@mui/material";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { getContext } from "../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import YearlyActivitiesGrid from "./YearlyActivitiesGrid";
import { YearlyActivitiesEnum } from "./YearlyActivitiesEnum/YearlyActivitiesEnum";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import {
  getSNJYDepositRequestExportToExcel,
  GetSNJYWithdrawRequestExportToExcel,
} from "../../Helpers/APIEndPoints/EndPoints";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import "./YearlyActivities.css";
import { AppModules } from "../../Helpers/Enums/AppModules";

import YearlyActivitiesFilters from "./Filters/YearlyActivitiesFilters";
import { IActivitiesTab } from "./Interfaces/IActivitiesTab";
import { IActivityGridFilters } from "./Grid/YearlyActGrid";

const YearlyActivitiesDashboard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const context = getContext();
  const [searchText, setSearchText] = useState("");
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentFilters, setCurrentFilters] =
    useState<IActivityGridFilters>(null);
  const [dataCount, setDataCount] = useState(0);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  let MemberId = context.MemberId;
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  // const [tabs, setTabs] = useState<IActivitiesTab[]>([]);

  const [tabs, setTabs] = useState<IActivitiesTab[]>([
    {
      label: "Yearly Divided",
      value: { ...a11yProps(0) },
      count: 0,
      active: true,
      visible: true,
      id: "Yearly-Divided",
      target: YearlyActivitiesEnum.YearlyDivident,
    },
    {
      label: "Share Certificate",
      value: { ...a11yProps(1) },
      count: 0,
      active: false,
      visible: true,
      id: "Share-Certificate",
      target: YearlyActivitiesEnum.ShareCertificate,
    },
  ]);

  // Function to toggle tab visibility based on appModule

  // useEffect(() => {
  //   const newTabs = [
  //     {
  //       label: "Yearly Divided",
  //       value: { ...a11yProps(0) },
  //       count: 0,
  //       active: true,
  //       visible: true,
  //       id: "Yearly-Divided",
  //       target: YearlyActivitiesEnum.YearlyDivident,
  //     },
  //     {
  //       label: "Share Certificate",
  //       value: { ...a11yProps(1) },
  //       count: 0,
  //       active: false,
  //       visible: true,
  //       id: "Share-Certificate",
  //       target: YearlyActivitiesEnum.ShareCertificate,
  //     },
  //   ];

  //   if (context?.CurrentRoleId === RoleEnum.Member) {
  //     setTabs(newTabs);
  //   } else if (context?.CurrentRoleId === RoleEnum.InternalTeam) {
  //     const internalTeamTab = newTabs.find(
  //       (tab) => tab.id === "Share-Certificate"
  //     );
  //     if (internalTeamTab) {
  //       internalTeamTab.active = true;
  //     }
  //     setTabs([internalTeamTab]);
  //   }
  // }, [context?.CurrentRoleId]);

  useEffect(() => {
    setTabs((prevTabs) => {
      return prevTabs.map((tab) => {
        return { ...tab, visible: true };
      });
    });
  }, []);

  const changeTab = (tabNum) => {
    const newTabs = [...tabs];
    newTabs.forEach((nt) => (nt.active = false));
    newTabs[tabNum].active = true;
    setTabs(newTabs);
  };

  const ExportToExcel = async (url, fileNamePrefix) => {
    const params = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      FromDate: currentFilters?.fromDate || "",
      ToDate: currentFilters?.toDate || "",
      MemberId: MemberId,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: url,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(
          response.data,
          `${fileNamePrefix}` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
      
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const handleEvents = (target: YearlyActivitiesEnum, event: any = null) => {
    switch (target) {
      case YearlyActivitiesEnum.YearlyDivident:
        changeTab(0);
        break;
      case YearlyActivitiesEnum.ShareCertificate:
        changeTab(1);
        break;
      case YearlyActivitiesEnum.FilterClick:
        setDashboardFilterOn(!dashboardFilterOn);
        break;
      case YearlyActivitiesEnum.SearchClick:
        setSearchText(event?.target?.value);
        break;

      case YearlyActivitiesEnum.ExportToExcelClick:
        if (dataCount === 0) {
          notify(ToastType.Error, "No data available");
        } else {
          let exportUrl, fileNamePrefix;
          const activeTab = tabs.find((tab) => tab.active);
          if (activeTab) {
            switch (activeTab.id) {
              case "Yearly-Divided":
                exportUrl = getSNJYDepositRequestExportToExcel;
                fileNamePrefix = "YearlyDividedReport_";
                break;
              case "Share-Certificate":
                exportUrl = GetSNJYWithdrawRequestExportToExcel;
                fileNamePrefix = "ShareCertificateReport_";
                break;
              default:
                break;
            }
          }

          if (exportUrl && fileNamePrefix) {
            ExportToExcel(exportUrl, fileNamePrefix);
          }
        }
        break;
    }
  };

  const TabsComponent = ({ tab }) => {
    const { count, active, id, target, label } = tab;
    return (
      <StyledBadge
        badgeContent={count}
        color="error"
        className="mr-3"
        max={99}
        invisible={true}
      >
        <li className="nav-item" role="presentation">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            key="Dashboard"
            className={active ? "nav-link active" : "nav-link"}
            id={id}
            data-toggle="pill"
            role="tab"
            aria-controls="pills-MA"
            aria-selected={active ? "true" : "false"}
            onClick={() => handleEvents(target)}
          >
            {label}
          </a>
        </li>
      </StyledBadge>
    );
  };

  return (
    <>
      <div className="">
        <div className="clearfix"></div>
        <div className="page-content row filter-row-container m-0 no-gutters">
          <div className="transformer-tabs col-lg-12 col-md-12">
            <div className="meeting-tabs tabs-main col-lg-12 p-0">
              <div className="col-lg-12 p-0">
                <div className="row">
                  <div className="col-lg-6 no-gutters">
                    <nav className="tabs mr-sm-4 --jsfied">
                      <ul
                        className="nav nav-pills  float-left with_tab"
                        id="pills-tab"
                        role="tablist"
                      >
                        {tabs.map((tab) => {
                          if (!tab.visible) return null;
                          return <TabsComponent tab={tab} key={tab.id} />;
                        })}
                      </ul>
                    </nav>
                  </div>
                  <div className="col-lg-6 d-flex justify-content-end no-gutters">
                    {/* <div className="col-lg-6">
                      <div className="input-group">
                        <input
                          className="form-control py-2 border-right-0 border"
                          type="Search"
                          value={searchText}
                          placeholder="Search"
                          onChange={(e) => setSearchText(e.target.value)}
                        />

                        <span className="input-group-append">
                          <div className="input-group-text bg-transparent">
                            <i className="fa fa-search"></i>
                          </div>
                        </span>
                      </div>
                    </div> */}
                    <Tooltip
                      title="Filters"
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    >
                      <ButtonComponent
                        onClick={() =>
                          handleEvents(YearlyActivitiesEnum.FilterClick)
                        }
                        className="btn btn-submit"
                        icon={"fa fa-filter"}
                        value=""
                      />
                    </Tooltip>

                    {/* <Tooltip
                      title={"Export to excel"}
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    >
                      <button
                        className="btn btn-submit"
                        onClick={() => {
                          handleEvents(YearlyActivitiesEnum.ExportToExcelClick);
                        }}
                      >
                        <i className="fa fa-download"></i>
                      </button>
                    </Tooltip> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <YearlyActivitiesFilters
          activeTab={tabs.find((t) => t.active)}
          dashboardFilterOn={dashboardFilterOn}
          setCurrentFilters={setCurrentFilters}
        />

        <YearlyActivitiesGrid
          searchText={searchText}
          setSearchText={setSearchText}
          activeTab={tabs.find((t) => t.active)}
          currentFilters={currentFilters}
          dataCount={dataCount}
          setDataCount={setDataCount}
          setCurrentDataReqObj={setCurrentDataReqObj}
        />
      </div>
    </>
  );
};

export default YearlyActivitiesDashboard;
